@if (company) {
  <div class="compliance-settings">
    @if (isAllowedToEditSettings()) {
      <div class="action-row justify-end compliance-settings__head">
        <button
          type="button"
          class="btn btn-primary"
          (click)="saveComplianceSettings()"
        >
          <i class="bi bi-check-lg me-1"></i>
          Save compliance settings
        </button>
      </div>
    }

    <app-display-card [justifyContent]="'start'">
      <header class="compliance-settings__overview-head">
        <div>
          <h3 class="mb-0">Compliance program</h3>
          <p class="compliance-settings__overview-sub mb-0">
            Service tier:
            <span class="chip chip-host" appStatusStyleChanges>
              {{
                company.fullServiceOffsite && company.fullServiceOnsite
                  ? 'FULL'
                  : 'BASE'
              }}
            </span>
          </p>
        </div>
        @if (isAllowedToEditSettings()) {
          <button
            type="button"
            class="btn btn-outline btn-sm"
            (click)="conFigureComplianceType()"
          >
            <i class="bi bi-sliders me-1"></i>
            Configure types
          </button>
        }
      </header>

      <div class="row g-3">
        <div class="col-md-5">
          <div class="form-group mb-0">
            <label class="form-label" for="complianceType">
              Compliance type
            </label>
            <select
              id="complianceType"
              class="form-select"
              (change)="onComplianceTypeChange()"
              [(ngModel)]="selectedComplianceType"
            >
              @for (item of companyComplianceTypes; track item) {
                <option [ngValue]="item">{{ item.type }}</option>
              }
            </select>
          </div>

          @if (!hasGlobalCompliance) {
            <div class="compliance-settings__risk-toggles">
              <div class="form-check">
                <input
                  id="riskLevel2"
                  type="checkbox"
                  class="form-check-input"
                  (change)="onEnableRiskLevelChange(2)"
                  [(ngModel)]="enableRiskLevel2"
                />
                <label for="riskLevel2" class="form-check-label">
                  Enable Risk Level 2 compliance
                </label>
              </div>
              <div class="form-check">
                <input
                  id="riskLevel3"
                  type="checkbox"
                  class="form-check-input"
                  (change)="onEnableRiskLevelChange(3)"
                  [(ngModel)]="enableRiskLevel3"
                />
                <label for="riskLevel3" class="form-check-label">
                  Enable Risk Level 3 compliance
                </label>
              </div>
            </div>
          }
        </div>

        <div class="col-md-7">
          <label class="form-label mb-1">Sample certificate URLs</label>
          <div class="compliance-settings__sample-urls">
            @for (item of complianceSettings; track item) {
              <div class="compliance-settings__sample-url">
                <span class="compliance-settings__sample-url-label">
                  {{
                    hasGlobalCompliance
                      ? 'Global'
                      : 'Risk Level ' + item.riskLevel
                  }}
                </span>
                <div class="compliance-settings__sample-url-actions">
                  <button
                    type="button"
                    class="btn btn-outline btn-sm"
                    (click)="copyUrl(item.sampleCert || null)"
                  >
                    <i class="bi bi-clipboard me-1"></i>
                    Copy
                  </button>
                  @if (isAllowedToEditSettings()) {
                    <button
                      type="button"
                      class="btn btn-outline btn-sm"
                      (click)="updateUrl(item.sampleCert || null, item)"
                    >
                      <i class="bi bi-pencil me-1"></i>
                      Update
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        </div>

        @if (selectedComplianceType) {
          <div class="col-12">
            <div class="form-group mb-0">
              <label for="descriptionOfOperations" class="form-label">
                Description of operations
              </label>
              <textarea
                class="form-control"
                id="descriptionOfOperations"
                rows="3"
                [(ngModel)]="selectedComplianceType.descriptionOfOperations"
                placeholder="Describe the operations covered by this compliance program."
              ></textarea>
            </div>
          </div>
        }
      </div>
    </app-display-card>

    @if (
      company.country !== 'CA' &&
      (company.allowAutomatedBusinessVerificationClientRegisteredVendors ||
        company.usesNewBusinessVerification)
    ) {
      <app-compliance-business-verified-company-background-checks
        [businessComplianceSettingForms]="businessComplianceForms"
      ></app-compliance-business-verified-company-background-checks>
    }

    <app-compliance-company-background-checks
      [Company]="company"
      [complianceSettingForms]="complianceSettingForms"
    ></app-compliance-company-background-checks>

    @if (company.fullServiceOnsite) {
      <app-compliance-owner-background-checks
        [complianceSettingForms]="complianceSettingForms"
      ></app-compliance-owner-background-checks>
    }

    @if (complianceSettingForms) {
      <app-compliance-general-liability
        [complianceSettingForms]="complianceSettingForms"
        [company]="company"
        [amBestValueMap]="amBestValueMap"
        [amBestFinancialValueMap]="amBestFinancialSize"
        (updateRequiredFields)="checkIsRequired($event)"
      ></app-compliance-general-liability>
    }

    @if (complianceSettingForms) {
      <app-compliance-auto-liability
        [complianceSettingForms]="complianceSettingForms"
        [company]="company"
        [amBestValueMap]="amBestValueMap"
        [amBestFinancialValueMap]="amBestFinancialSize"
        (updateRequiredFields)="checkIsRequired($event)"
      ></app-compliance-auto-liability>
    }

    @if (
      complianceSettingForms &&
      complianceSettingForms.length > 0 &&
      complianceSettings
    ) {
      <app-compliance-umbrella-liability
        [complianceSettingForms]="complianceSettingForms"
        [amBestValueMap]="amBestValueMap"
        [amBestFinancialValueMap]="amBestFinancialSize"
        (updateRequiredFields)="checkIsRequired($event)"
      ></app-compliance-umbrella-liability>
    }

    @if (
      complianceSettingForms &&
      complianceSettingForms.length > 0 &&
      complianceSettings
    ) {
      <app-compliance-workers-compensation
        [company]="company"
        [complianceSettingForms]="complianceSettingForms"
        [amBestValueMap]="amBestValueMap"
        [amBestFinancialValueMap]="amBestFinancialSize"
        (updateRequiredFields)="checkIsRequired($event)"
      ></app-compliance-workers-compensation>
    }

    @if (complianceSettingForms) {
      <app-compliance-professional-liability
        [complianceSettingForms]="complianceSettingForms"
        [company]="company"
        [amBestValueMap]="amBestValueMap"
        [amBestFinancialValueMap]="amBestFinancialSize"
        (updateRequiredFields)="checkIsRequired($event)"
      ></app-compliance-professional-liability>
    }

    @if (!company.hasGlobalCompliance) {
      <app-compliance-trade-specific-compliance-tiers
        [complianceSettingForms]="complianceSettingForms"
        [complianceSettings]="complianceSettings"
        [enableRiskLevel2]="enableRiskLevel2"
        [enableRiskLevel3]="enableRiskLevel3"
      ></app-compliance-trade-specific-compliance-tiers>
    }

    @if (isAllowedToEditSettings()) {
      <div class="action-row justify-end compliance-settings__footer">
        <button
          type="button"
          class="btn btn-primary"
          (click)="saveComplianceSettings()"
        >
          <i class="bi bi-check-lg me-1"></i>
          Save compliance settings
        </button>
      </div>
    }
  </div>
}
